import React, { Component } from 'react'
import Sidebar from './common/sidebar_components/sidebar';
import Right_sidebar from './common/right-sidebar';
import Footer from './common/footer';
import Header from './common/header_components/header';
import VerHeader from './common/header_components/ver-header';
import AuthService from './services/auth.service';
import { isSessionValid, redirectToLogin, expireSession, getTokenExpiration } from './services/session';

export class App extends Component {
    constructor(props){
        super(props);
        this.state ={
            ltr:true,
            divName:'RTL',
        }
    }
    componentDidMount() {
        // Rutas protegidas: sin sesión o con el token vencido, al login
        if (!isSessionValid()) {
            if (AuthService.getCurrentUser()) {
                expireSession();
            } else {
                redirectToLogin(false);
            }
            return;
        }

        // Si la pestaña queda abierta, cerrar la sesión justo al vencer el token
        const user = AuthService.getCurrentUser();
        const exp = getTokenExpiration(user.token);
        if (exp) {
            // setTimeout no admite más de ~24.8 días; el token dura 24h
            const wait = Math.min(exp - Date.now(), 2147483647);
            this.expiryTimer = setTimeout(expireSession, wait);
        }
    }
    componentWillUnmount() {
        clearTimeout(this.expiryTimer);
    }
    ChangeRtl(divName){
        if(divName === 'RTL') {
            document.body.classList.add('rtl');
            this.setState({divName: 'LTR'});
        }else{
            document.body.classList.remove('rtl');
            this.setState({divName: 'RTL'});
        }
    }
    render() {
        // No mostrar la pantalla mientras se redirige al login
        if (!isSessionValid()) {
            return null;
        }
        return (
            <div>
                <div className="page-wrapper" >
                    <VerHeader />
                    <div className="page-body-wrapper">
                        <Sidebar />
                        <Right_sidebar />
                        <div className="page-body">
                            {this.props.children}
                        </div>
                            <Footer />
                    </div>
                </div>
                <div className="btn-light custom-theme" onClick={ () => this.ChangeRtl(this.state.divName)}>{this.state.divName}</div>
            </div>
        )
    }
}

export default App
